import { render } from "./DistributionPlotsSection.vue?vue&type=template&id=020f77b0&scoped=true"
import script from "./DistributionPlotsSection.vue?vue&type=script&lang=js"
export * from "./DistributionPlotsSection.vue?vue&type=script&lang=js"

import "./DistributionPlotsSection.vue?vue&type=style&index=0&id=020f77b0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020f77b0"]])

export default __exports__